var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalMinutes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m30.4 33.546-1.551 1.552c-.608.608-1.472.88-2.527.88-3.456 0-9.007-3.072-14.078-8.095l-.064-.064-.064-.064c-6.559-6.623-9.79-14.03-7.214-16.605L6.437 9.6s.016 0 .032-.032c.848-.8 2.192-.784 3.008.032l3.183 3.183a2.134 2.134 0 0 1 0 3.04l-2.335 2.335c-.992.992.8 4.351 3.983 7.535 3.183 3.183 6.543 4.959 7.534 3.983l1.328-1.328 1.008-1.008a2.115 2.115 0 0 1 3.023 0l3.2 3.184a2.143 2.143 0 0 1 0 3.023z",
    fill: "url(#aysltedjda)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.033 33.916 28.849 35.1c-.608.608-1.472.88-2.527.88-3.456 0-9.007-3.072-14.078-8.095l-.064-.064-.064-.064c-6.559-6.622-9.79-14.029-7.214-16.605L6.085 9.97c-2.575 2.575.656 9.982 7.215 16.605.016.016.048.032.064.064l.064.064c5.07 5.023 10.622 8.094 14.077 8.094 1.056 0 1.92-.272 2.528-.88z",
    fill: "url(#3vlwr89g6b)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21.597c0-4.703-1.824-9.119-5.151-12.446A17.499 17.499 0 0 0 18.403 4m0 10.638c1.856 0 3.6.72 4.927 2.032a6.906 6.906 0 0 1 2.032 4.927m5.343 0c0-3.152-1.2-6.303-3.6-8.703a12.27 12.27 0 0 0-8.702-3.599m13.31 22.924-2.88 2.88c-.607.607-1.471.879-2.527.879-3.456 0-9.007-3.072-14.078-8.095l-.063-.063-.064-.064c-6.56-6.623-9.79-14.03-7.215-16.605l2.863-2.88a2.163 2.163 0 0 1 3.04 0l3.183 3.184a2.134 2.134 0 0 1 0 3.039l-2.335 2.336c-.992.991.8 4.35 3.983 7.534 3.183 3.183 6.543 4.96 7.534 3.983l2.336-2.335a2.115 2.115 0 0 1 3.023 0l3.2 3.183a2.143 2.143 0 0 1 0 3.024z",
    stroke: "url(#qd8o4948jc)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aysltedjda",
    x1: 4.016,
    y1: 24.678,
    x2: 30.815,
    y2: 15.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3vlwr89g6b",
    x1: 4.016,
    y1: 25.095,
    x2: 29.831,
    y2: 16.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qd8o4948jc",
    x1: 4,
    y1: 22.596,
    x2: 35.749,
    y2: 12.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMinutes);
export default __webpack_public_path__ + "static/media/localMinutes.1100e5cda90cf7f8e2a3744c7efd93f0.svg";
export { ForwardRef as ReactComponent };